

import Vue from 'vue'
import { assetURL } from '@/utils'

const transformer = ({ cfdi, against_receipt: againtsReceipt = [], complements = [] }) => {
  let invoice = [
      {
        id: cfdi.id,
        name: 'Factura  (CFDI)',
        file: assetURL(cfdi.pdf_file),
        isActive: cfdi.is_active,
      },
      ...againtsReceipt.map(({id, file_invoiceReceipt, stamped_file, is_active}) => ({
        name: 'Contrarecibo',
        id: id,
        file: file_invoiceReceipt,
        stampedFile: stamped_file,
        isActive: is_active,
      })).filter(({isActive}) => isActive)
    ]
    if (complements.length) {
      invoice.push(
         {
          name: 'Complementos de pago',
          files: complements.map(r => ({
            id: r && r.id,
            file: r && r.pdf_proof_payment,
          }))
        }
      )
    }
    return invoice
}

const fetchTaxReceiptFiles = affectedId =>
  Vue.$http.get(`/taxreceipt/invoice-of-sinister/${affectedId}/`, affectedId)
    .then(({ data }) => {
      return data.map(d => transformer(d))
    })

export default fetchTaxReceiptFiles



// WEBPACK FOOTER //
// ./src/services/taxReceipt/fetchTaxReceiptFiles.js